import { render, staticRenderFns } from "./PluginCenter.vue?vue&type=template&id=634da24a"
import script from "./PluginCenter.vue?vue&type=script&lang=js"
export * from "./PluginCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports